<p-editor #editor [readonly]="true" [style]="{ height: '100%', 'min-height': 'fit-content' }" (onInit)="onLoaded()">
  <ng-template #header></ng-template>
</p-editor>
